import { Calendar } from "primereact/calendar";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { FloatLabel } from "primereact/floatlabel";

const CalendarInput = ({
  name,
  control,
  label,
  errors,
  isRequired,
  onChange,
  disabled,
  minDate,
  maxDate,
  defaultValue,
  view,
  dateFormat = "dd/mm/yy",
  mask = "99/99/9999",
  placeholder = "dd/mm/aaaa",
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={{ required: isRequired ? "Campo obrigatório" : false }}
      render={({ field, fieldState }) => (
        <>
          <label
            htmlFor={field.name}
            className={fieldState.error ? "p-error" : ""}
          ></label>
          <FloatLabel className="w-100">
            <Calendar
              style={{ height: "2.6rem" }}
              inputId={field.name}
              value={field.value}
              maxDate={maxDate}
              minDate={minDate}
              onChange={(e) => {
                field.onChange(e.target.value);
                onChange && onChange(e);
              }}
              disabled={disabled}
              dateFormat={dateFormat}
              mask={mask}
              placeholder={placeholder}
              className={`w-100 p-inputtext-sm rounded-4 ${classNames({
                "p-invalid": fieldState.error,
              })}`}
              {...(view ? { view } : {})}
              locale="pt"
              showButtonBar
              showIcon
            />
            <label htmlFor={field.name}>{label}</label>
          </FloatLabel>

          {errors && errors[name] && (
            <span className="p-error">{errors[name].message}</span>
          )}
        </>
      )}
    />
  );
};

export default CalendarInput;
